var Handlebars = require("../../node_modules/.pnpm/handlebars@4.7.9_patch_hash=53ad8d748fa2ca3a7a0502c46f2ed1236eef8162efec84c06849dc83ad9e28e9/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"0":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a class=\"stream-topic\" data-stream-id=\""
    + alias3(alias2(alias1(depth0, "channel_id", {"start":{"line":2,"column":42},"end":{"line":2,"column":52}} ), depth0))
    + "\" href=\""
    + alias3(alias2(alias1(depth0, "href", {"start":{"line":2,"column":64},"end":{"line":2,"column":68}} ), depth0))
    + "\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"stream"),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(2, data, 0),"data":data,"loc":{"start":{"line":4,"column":4},"end":{"line":8,"column":12}}})) != null ? stack1 : "")
    + " &gt; <span class=\"empty-topic-display\">"
    + ((stack1 = alias2(alias1(depth0, "topic_display_name_html", {"start":{"line":8,"column":55},"end":{"line":8,"column":78}} ), depth0)) != null ? stack1 : "")
    + "</span></a>";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(require("./decorated_channel_name.hbs"),undefined,{"name":"decorated_channel_name","hash":{"show_colored_icon":false,"inline_with_text":true,"stream":lookupProperty(depth0,"stream")},"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"2":function(container,depth0,helpers,partials,data) {
    return "#"
    + container.escapeExpression(container.lambda(container.strict(depth0, "channel_name", {"start":{"line":7,"column":7},"end":{"line":7,"column":19}} ), depth0));
},"3":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.strict, alias2=container.lambda, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<a class=\"stream-topic\" data-stream-id=\""
    + alias3(alias2(alias1(depth0, "channel_id", {"start":{"line":12,"column":42},"end":{"line":12,"column":52}} ), depth0))
    + "\" href=\""
    + alias3(alias2(alias1(depth0, "href", {"start":{"line":12,"column":64},"end":{"line":12,"column":68}} ), depth0))
    + "\">"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"stream"),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(2, data, 0),"data":data,"loc":{"start":{"line":14,"column":4},"end":{"line":18,"column":12}}})) != null ? stack1 : "")
    + " &gt; "
    + ((stack1 = alias2(alias1(depth0, "topic_display_name_html", {"start":{"line":18,"column":21},"end":{"line":18,"column":44}} ), depth0)) != null ? stack1 : "")
    + "</a>";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),lookupProperty(depth0,"is_empty_string_topic"),{"name":"if","hash":{},"fn":container.program(0, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":21,"column":8}}})) != null ? stack1 : "");
},"usePartial":true,"useData":true});